export const tableSorter = (a, b, key) => a?.[key]?.localeCompare(b?.[key]);

// Sorting direction constants
export const SORT_DIRECTION = {
  ASC: "asc",
  DESC: "desc",
  ASCEND: "ascend",
  DESCEND: "descend",
};

/**
 * antd column `sortOrder` <- API ordering.
 * Returns "ascend"/"descend" when the API is ordering by `field`, else null
 * (null = the column's unsorted state, i.e. antd's 3rd click).
 */
export const toAntdSortOrder = (orderBy, orderDirection, field) => {
  if (orderBy !== field) return null;
  return orderDirection === SORT_DIRECTION.DESC ? SORT_DIRECTION.DESCEND : SORT_DIRECTION.ASCEND;
};

/**
 * API ordering <- antd `sorter.order`.
 * antd sends "ascend" | "descend" | undefined (undefined = sort cleared).
 * Returns undefined when cleared so no ordering is sent.
 */
export const toApiSortDirection = antdOrder => {
  if (!antdOrder) return undefined;
  return antdOrder === SORT_DIRECTION.DESCEND ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC;
};
